(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var f = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var withSpace = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var amount = parts[1] === '00' ? withSpace : withSpace + ',' + parts[1];
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return withSpace;
      if (k === 'amount_with_comma_separator') return withSpace + ',' + parts[1];
      return amount;
    });
  }

  /* Drawers */
  function openDrawer(id) { var d = document.getElementById(id); if (!d) return; d.classList.add('is-open'); document.body.style.overflow = 'hidden'; var f = d.querySelector('input,button,a'); if (f) setTimeout(function () { f.focus(); }, 50); }
  function closeDrawers() { $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); }); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]:not([data-open-drawer=""])');
    if (o) {
      if (o.getAttribute('data-open-drawer') === 'cart-drawer' && !document.getElementById('cart-drawer')) return;
      e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return;
    }
    if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('drawer__overlay')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* Cart drawer */
  function refreshCartUI() {
    return fetch(window.theme.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (s) {
      var tmp = document.createElement('div');
      if (s['cart-drawer']) {
        tmp.innerHTML = s['cart-drawer'];
        var nb = tmp.querySelector('.drawer__inner'), cb = $('#cart-drawer .drawer__inner');
        if (nb && cb) cb.innerHTML = nb.innerHTML;
      }
      return fetch(window.theme.routes.cartJs).then(function (r) { return r.json(); });
    }).then(function (cart) {
      $$('.cart-count').forEach(function (el) { el.textContent = cart.item_count || ''; el.setAttribute('data-count', cart.item_count); });
      return cart;
    });
  }
  window.theme.refreshCart = refreshCartUI;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (window.theme.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { var err = $('[data-form-error]', form); if (err) { err.textContent = res.description || res.message; err.hidden = false; } return; }
        return refreshCartUI().then(function () { openDrawer('cart-drawer'); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  function changeLine(line, qty) {
    return fetch(window.theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var line = +b.getAttribute('data-line'), qty = +b.getAttribute('data-qty');
    changeLine(line, qty).then(function () {
      if (b.closest('#cart-drawer')) return refreshCartUI();
      window.location.reload();
    });
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]');
    if (!i) return;
    changeLine(+i.getAttribute('data-line'), Math.max(0, +i.value)).then(function () {
      if (i.closest('#cart-drawer')) return refreshCartUI();
      window.location.reload();
    });
  });

  /* Quantity stepper on product page */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = $('input', b.parentNode);
    var v = Math.max(1, (+input.value || 1) + (+b.getAttribute('data-qty-step')));
    input.value = v;
  });

  /* Slideshow */
  function initSlideshow(root) {
    var track = $('.slideshow__track', root), slides = $$('.slide', root), dots = $$('.slideshow__dot', root);
    if (!track || slides.length < 2) return;
    var i = 0, timer, auto = +root.getAttribute('data-autoplay') || 0;
    function go(n) { i = (n + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); mark(); }
    function mark() { dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
    track.addEventListener('scroll', function () { var n = Math.round(track.scrollLeft / track.clientWidth); if (n !== i) { i = n; mark(); } }, { passive: true });
    function restart() { clearInterval(timer); if (auto) timer = setInterval(function () { go(i + 1); }, auto * 1000); }
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    restart(); mark();
  }
  $$('[data-slideshow]').forEach(initSlideshow);

  /* Ticker: duplicate content for seamless loop */
  $$('[data-ticker]').forEach(function (t) {
    var track = $('.ticker__track', t), g = $('.ticker__group', t);
    if (!track || !g) return;
    var clone = g.cloneNode(true); clone.setAttribute('aria-hidden', 'true'); track.appendChild(clone);
    var w = g.getBoundingClientRect().width, speed = +t.getAttribute('data-speed') || 1.5;
    track.style.setProperty('--ticker-duration', Math.max(8, w / (speed * 40)) + 's');
  });

  /* Product gallery + variants */
  function initProduct(root) {
    var slides = $$('.gallery__slide', root), thumbs = $$('.gallery__thumb', root);
    function show(id) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id)); });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') === String(id) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-media-id')); }); });
    var form = $('form[data-product-form]', root), dataEl = $('[data-variants]', root);
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    function current() {
      var opts = $$('.variant-group', form).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      return variants.filter(function (v) { return opts.every(function (o, k) { return v.options[k] === o; }); })[0];
    }
    function update() {
      var v = current();
      var idInput = $('[name=id]', form), btn = $('[data-atc]', form), price = $('[data-price]', root);
      if (!v) { if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Indisponible'; } return; }
      idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btn.getAttribute('data-label') : 'Épuisé'; }
      if (price) {
        var sale = v.compare_at_price > v.price;
        price.innerHTML = '<span class="price__current">' + formatMoney(v.price) + '</span>' + (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '');
        price.classList.toggle('price--sale', sale);
      }
      if (v.featured_media_id) show(v.featured_media_id);
      $$('[data-sticky-price]').forEach(function (el) { el.textContent = formatMoney(v.price); });
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.variant-group')) update(); });
  }
  $$('[data-product]').forEach(initProduct);

  /* Sticky add-to-cart */
  var sticky = $('.sticky-atc'), buy = $('[data-atc]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(buy);
    $('[data-sticky-atc-btn]', sticky).addEventListener('click', function () { buy.click(); });
  }

  /* Sticky header (hide on scroll down, show on scroll up) */
  var hdr = $('.shopify-section-header-sticky');
  if (hdr) {
    var last = window.scrollY, hh = hdr.offsetHeight;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      hdr.style.transition = 'transform .3s';
      hdr.style.transform = (y > last && y > hh * 2) ? 'translateY(-110%)' : 'none';
      last = y;
    }, { passive: true });
  }

  /* Scroll to top */
  var st = $('.scroll-top');
  if (st) {
    window.addEventListener('scroll', function () { st.hidden = window.scrollY < 600; }, { passive: true });
    st.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Reveal animations */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: .1 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }
})();

/* Product recommendations (async) */
(function () {
  var el = document.querySelector('[data-recs]');
  if (!el) return;
  fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
    var d = document.createElement('div'); d.innerHTML = html;
    var inner = d.querySelector('.color-background-1');
    if (inner) el.replaceWith(inner);
  }).catch(function () {});
})();
